import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocaleDatePipe } from './locale-date.pipe';
import { LocaleNumberPipe } from './locale-number.pipe';
import { LocaleLabelPipe, LocaleListPipe } from './locale-punctuation.pipe';

@NgModule({
  declarations: [LocaleDatePipe, LocaleNumberPipe],
  imports: [CommonModule, LocaleLabelPipe, LocaleListPipe],
  exports: [LocaleDatePipe, LocaleNumberPipe, LocaleLabelPipe, LocaleListPipe],
})
export class PipesModule {}
